import { render, staticRenderFns } from "./user-agreement.html?vue&type=template&id=63803c2e&scoped=true&external"
import script from "./user-agreement.js?vue&type=script&lang=js&external"
export * from "./user-agreement.js?vue&type=script&lang=js&external"
import style0 from "./user-agreement.scss?vue&type=style&index=0&id=63803c2e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63803c2e",
  null
  
)

export default component.exports